import { Box, Typography } from '@mui/material';
import { FolderUp } from 'lucide-react';
import { useIntl } from 'react-intl';
import { QuietButton } from '~/containers/patient-list/shared';
import type { DiskImport } from '../hooks';

/**
 * The way into a file import from the search view: files dropped anywhere on the dialog, or picked.
 * Either one replaces the search with the review of what was read, so the offer is withdrawn while a
 * retrieval is being set up and a drop would take the screen from under it.
 */
export default function FileImportStrip({
    picker,
}: {
    picker: DiskImport['picker'];
}) {
    const intl = useIntl();
    return (
        <Box
            sx={{
                flex: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                py: 0.75,
                px: 2,
                borderTop: 1,
                borderColor: 'divider',
                color: 'text.secondary',
            }}
        >
            <FolderUp size={14} aria-hidden />
            <Typography sx={{ fontSize: 12, flex: 1, minWidth: 0 }} noWrap>
                {intl.formatMessage({ id: 'patientList.import.filesStrip' })}
            </Typography>
            <QuietButton onClick={picker.chooseFolder}>
                {intl.formatMessage({
                    id: 'patientList.import.dropzone.chooseFolder',
                })}
            </QuietButton>
            <QuietButton onClick={picker.chooseFiles}>
                {intl.formatMessage({
                    id: 'patientList.import.dropzone.chooseFiles',
                })}
            </QuietButton>
        </Box>
    );
}
